/**
 * Ime aplikacije za uporabnike (blagovna znamka, spletna aplikacija na app.avtopisarna.si). Interno – v kodi, modulih,
 * glavah X-Hera-* in na strežniku – ostaja Hera. Logotip: postavitev/Logotip.tsx, ikona: public/ikona.svg.
 */
export const IME_APLIKACIJE = 'Avto Pisarna';
